/* tslint:disable */
import { Component } from '@angular/core';
import { MdDialog, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';

import { environment } from 'environments/environment';

import { ConstantsService } from 'app/services/constants-service';

import { ChangePasswordComponent } from './changepassword/change-password.component';
import { LogoutService } from './logout.service';

@Component({
    selector: 'user-settings',
    templateUrl: './user-settings.component.html'
})
export class UserSettingsComponent {
    config: MdDialogConfig = {
        disableClose: true,
        width: '',
        height: '',
        position: {
            top: '',
            bottom: '',
            left: '',
            right: ''
        }
    };

    constructor(
        private dialog: MdDialog,
        private router: Router,
        private logoutService: LogoutService
    ) { }

    openUserPreferences() {
        this.router.navigateByUrl('/userPreferences');
    }

    openChangePasswordDialog() {
        this.dialog.open(ChangePasswordComponent, this.config);
    }

    openArchival() {
        this.router.navigateByUrl('/archivals');
    }

    openProcesses() {
        this.router.navigateByUrl('/processes');
    }

    logout() {
      this.logoutService.processLogout().subscribe(
          response => {
              if (response && response.flagResult) {
                  this.logoutService.deleteCredentials();
                  setTimeout(() =>
                    window.location.href = environment.production
                      ? `${window.location.origin}${window.location.pathname}${ConstantsService.LOGIN_URL}?lastPath=${window.location.href}`
                      : `${ConstantsService.LOGIN_URL}?lastPath=${window.location.href}`
                    , 3000);
              }
          });
    }
}



// WEBPACK FOOTER //
// ./src/app/header/usersettings/user-settings.component.ts